'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from '../styles/PricesHero.module.css';
import gradientStyles from '../styles/GradientOverlay.module.css';
import Image from 'next/image';

const PricesHero = () => {
  const pricesHeroRef = useRef(null);
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    // Use a slight delay to ensure DOM is fully hydrated
    const animationDelay = setTimeout(() => {
      const pricesHero = pricesHeroRef.current;
      if (!pricesHero) return;
      
      // Parallax effect for the background
      gsap.to(`.${styles.pricesBg}`, {
        scrollTrigger: {
          trigger: pricesHero,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        },
        y: '25%',
        ease: 'none'
      });
      
      // Text animation
      gsap.from(`.${styles.pricesHero} h1, .${styles.pricesHero} h3`, {
        scrollTrigger: {
          trigger: pricesHero,
          start: 'top 80%',
          end: 'center center',
          scrub: true
        },
        y: 50,
        opacity: 0,
        stagger: 0.3,
        ease: 'power3.out'
      });
    }, 100); // Small delay to ensure everything is rendered
    
    return () => clearTimeout(animationDelay);
  }, []);
  
  return (
    <section className={styles.pricesHero} id="prices" ref={pricesHeroRef}>
      <div className={styles.pricesBg}>
        <Image 
          src="https://imagedelivery.net/LOBxX7gyPpyC22XVZKaoOw/c7503bb8-08fa-43fa-0e60-ca266869fb00/public" 
          alt="Background gradient" 
          className={gradientStyles.gradientImage}
          width={1920}
          height={1080}
          priority
        />
        
      </div>
      <div className={styles.pricesHeroHeader}>
        <h1>GameMax App</h1>
        <h3>Elevate Your Pickleball Game</h3>
      </div>
    </section>
  );
};

export default PricesHero; 
